import { debugLogReportBusinessStep } from '@/src/components/Debug/Utils/debugGlobalData';
import { HomePageLoganType, logan } from './Logan';
import { HOME_PAGE_ERROR_CODE } from './constant';

const Raptor = Mach.requireModule('Raptor');

export class HomePageMonitor {
  /**
     * 通参
     */
  defaultTags = {
    osName: Mach.env.osName ?? '',
    osVersion: Mach.env.osVersion ?? '',
    appVersion: Mach.env.version ?? '',
    platform: Mach.env.isAndroid ? 'Android' : 'iOS',
    bundleVersion: Mach.env.bundleVersion,
  }

  /**
     * 采样率
     */
  sampleRate = 1.0;

  /**
     * 白屏监控指标上报
     */
  reportWhiteScreenRate = (value, params = {}) => {
    // status对应Value值，方便魔术查询
    const tags = { ...this.defaultTags, ...params, status: value };
    this.reportMetrics({ HomePageWhiteScreenRate: value }, tags);
  }

  /**
     * 上报首屏渲染时长
     * @param value 时长
     * @param params
     */
  reportRenderCostTime = (value, params = {}) => {
    const tags = { ...this.defaultTags, ...params };
    this.reportMetrics({ HomePageRenderCostTime: value }, tags);
  }

  reportRefreshRenderCostTime = (value, params = {}) => {
    const tags = { ...this.defaultTags, ...params };
    this.reportMetrics({ HomePageRefreshRenderCostTime: value }, tags);
  }

  /**
     * 分区块上报渲染时长
     */
  reportSectionRenderCostTime = (value, params = {}) => {
    const tags = { ...this.defaultTags, ...params };
    this.reportMetrics({ HomePageSectionRenderCostTime: value }, tags);
  }

  // feed提前曝光场景
  reportHomePageFeedsShow = (value, params = {}) => {
    const tags = { ...this.defaultTags, ...params, status: value };
    this.reportMetrics({ HomePageSectionRenderFeedsFirstShow: value }, tags);
  }

  /**
     * 上报Feed滚动可见事件
     * @param value  是否可见 Boolean
     * @param params  滑动距离，头部高度，数据长度
     */
  reportFeedScrollVisibleEvent = (value, params = {}, loganParam = {}) => {
    const tags = { ...this.defaultTags, ...params };
    this.reportMetrics({ FeedScrollVisibleEvent: value }, tags);
    logan(HomePageLoganType.Feed, {
      msg: 'reportFeedScrollVisibleEvent',
      FeedScrollVisibleEvent: value,
      ...tags,
      ...loganParam,
    });
  }

  // 首页语言浮层出现率
  reportHomePageUpdateLanguage = (value, params = {}) => {
    const tags = { ...this.defaultTags, ...params, status: value };
    this.reportMetrics({ HomePageUpdateLanguageEvent: value }, tags);
  }

  // 兜底组件状态
  reportHomePagePreheat = (value, params = {}) => {
    const tags = { ...this.defaultTags, ...params, code: value };
    this.reportMetrics({ HomePagePreheatEvent: value }, tags);
  }

  // 兜底组件code
  reportHomePagePreheatCode = (value, params = {}) => {
    let status = 0;
    if (value === HOME_PAGE_ERROR_CODE.PRE_PAGE_LOGIN_CODE || value === HOME_PAGE_ERROR_CODE.PRE_PAGE_NO_LOGIN_COE
       || value === HOME_PAGE_ERROR_CODE.LOGIN_CODE || value === HOME_PAGE_ERROR_CODE.NO_LOGIN_CODE
       || value === HOME_PAGE_ERROR_CODE.NO_SUPPLY_AREA || HOME_PAGE_ERROR_CODE.NO_DATA
       || value === 0) {
      // 正常态
      status = 1;
    }
    const tags = { ...this.defaultTags, ...params, code: value };
    this.reportMetrics({ HomePagePreheatCode: status }, tags);
  }

  /**
   * 上报首页 Header 数据状态
   */
  reportHeaderResponseDataAvailable = (value, params = {}, loganTag = {}) => {
    const tags = { ...this.defaultTags, ...params };
    this.reportMetrics({ HomeHeaderResponseDataAvailable: value }, tags);
    logan(HomePageLoganType.Feed, {
      msg: 'reportHomeHeaderResponseDataAvailable',
      HeaderResponseDataAvailable: value,
      ...tags,
      ...loganTag
    });
  }

  /**
     * 上报首页 Feed 数据返回为空比例,Feed请求返回时触发。
     * @param value  是否有商卡数据返回 Boolean
     * @param params  数据长度，pageNo
     */
  reportFeedResponseDataAvailable = (value, traceId, params = {}, loganTag = {}) => {
    const tags = { ...this.defaultTags, ...params };
    this.reportMetrics({ FeedResponseDataAvailable: value }, tags);
    logan(HomePageLoganType.Feed, {
      msg: 'reportFeedResponseDataAvailable',
      FeedResponseDataAvailable: value,
      traceId,
      ...tags,
      ...loganTag
    });
  }

  reportPageRenderAvailable = (value, params = {}) => {
    const tags = { ...this.defaultTags, ...params };
    this.reportMetrics({ HomePageRenderAvailable: value }, tags);
  }

  /**
     * 上报Report监控指标
     * @param params
     * @param tags
     */
  reportMetrics = (params, tags) => {
    const envName = Mach.env.isDebug ? 'Test' : 'Prod';
    const tagsObj = { ...tags, env: envName };
    // 校验tag数据是否为字符串
    const tagParams = this.checkAndConvertToString(tagsObj);
    Raptor?.reportMetrics?.(params, tagParams, this.sampleRate);
    this.debugReportBusinessStep(params);
  }

  /**
     * 检查Value类型是否为字符串并转换
     * @param obj
     * @returns
     */
  checkAndConvertToString = (obj) => {
    if (Array.isArray(obj) || typeof obj !== 'object') {
      return obj;
    }
    const convertObj = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (typeof obj[key] === 'string') {
          convertObj[key] = obj[key];
        } else if (typeof obj[key] === 'number') {
          convertObj[key] = String(obj[key]);
        }
      }
    }
    return convertObj;
  }

  // 上报主包业务异常
  reportBusinessException = (category, detail?: any, tags?: any, type = 'normal') => {
    if (!category) {
      return;
    }

    Raptor?.reportBusinessException(category, detail || {}, { ...this.defaultTags, ...tags, type });
  }

  /**
     * 触发下拉刷新错误
     */
  reporPullDownError = (params = {}) => {
    // status对应Value值，方便魔术查询
    const tags = { ...this.defaultTags, ...params, status: '1' };
    this.reportMetrics({ HomePageTriggerPullDownError: 1 }, tags);
  }

  debugReportBusinessStep = (params) => {
    if (Mach.env.isDebug) {
      try {
        const logStr = JSON.stringify(params);
        if (logStr) {
          debugLogReportBusinessStep('🐑Metrics', '🐑【Metrics】reportMetrics', logStr);
        }
        // console.log(logStr);
      } catch (error) {
        console.log('Logan ❌❌❌❌❌=====', error);
      }
    }
  }

  /**
     * 上报氛围数据状态
     */
  reportHeaderBgDataStatus = (params = {}) => {
    // status对应Value值，方便魔术查询
    const tags = { ...this.defaultTags, ...params, status: '1' };
    this.reportMetrics({ HomePageHeaderBgDataStatus: 1 }, tags);
  }

  /**
   * 上报氛围图片状态
   */
  reportHeaderBgImageStatus = (value, params = {}) => {
    // status对应Value值，方便魔术查询
    const tags = { ...this.defaultTags, ...params };
    this.reportMetrics({ HomePageHeaderBgImageStatus: value }, tags);
  }

  /**
   * 上报透明视频加载失败次数
   */
  reportHeaderBgVideoLoadFail = (params = {}) => {
    // status对应Value值，方便魔术查询
    const tags = { ...this.defaultTags, ...params };
    this.reportMetrics({ HomePageHeaderBgVideoLoadFail: 1 }, tags);
  }

  /**
   * 上报banner物料加载状态
   */
  reportBannerMediaStatus = (value, mediaType, params = {}) => {
    const tags = { ...this.defaultTags, ...params };
    if (mediaType === 'lottie') {
      this.reportMetrics({ HomePageBannerLottieLoadStatus: value }, tags);
    } else if (mediaType === 'image') {
      this.reportMetrics({ HomePageBannerImageLoadStatus: value }, tags);
    }
  }

  reportFilterRefreshStatus = (value, params = {}) => {
    const tags = { ...this.defaultTags, ...params, result: value ? 'success' : 'fail' };
    this.reportMetrics({ FilterRefreshResult: value }, tags);
  }
}
